// Basic
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
// Store & actions
import actionsContracts from '@/app/modules/contracts/api/actionsContracts';
import useContractStore from '@/app/store/modules/contract';
// Components
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import BodyAddContractForm from './components/BodyAddContractForm/BodyAddContractForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import { Modal, ModalContent } from '@/common-utils/components/ui/modal';
// Common
import EXTERNAL_CONTRACT_TYPES from '../../../enums/externalContractType';
import { useToast } from '@/common-utils/hooks/use-toast';
// Lang
import { nsMerchantUser } from '@/app/i18n/namespaces';

/**
 * @param {boolean} isOpen element that triggers modal opening
 * @param {function} onClose element that triggers modal opening
 * @returns {JSX} CustomPayModalAddExternalContract
 */
function CustomPayModalAddExternalContract({ isOpen, setIsOpen }) {

    // Url params
    const { contractAccessId: contractsAccessId } = useParams();

    // Toast
    const { toast } = useToast();

    // Store
    const { storeRefetchContracts } = useContractStore();

    // State
    const [validForm, setValidForm] = useState(false);
    const [formData, setFormData] = useState(false);

    // Constants
    const selectedExtContract = { type: EXTERNAL_CONTRACT_TYPES.ALMA };

    // Api Calls
    const onSuccess = () => {
        const entityName = selectedExtContract?.type?.name?.toLowerCase();
        storeRefetchContracts(true);
        setIsOpen(false);
        toast({
            description: <Entity namespace={nsMerchantUser} entity={`modal.add_external_contract.${entityName}.success`} />,
            variant: 'success'
        });
    };
    const onError = (error) => {
        const entityName = selectedExtContract?.type?.name?.toLowerCase();
        const errorCode = error?.response?.data?.errorCode ?? error?.code ?? 'UNKOWN_ERROR';
        setIsOpen(false);
        toast({
            description: <Entity namespace={nsMerchantUser} entity={`modal.add_external_contract.${entityName}.errors.${errorCode}`} />,
            variant: 'danger'
        });
    };
    const addContractByApiKey = actionsContracts.addContractByApiKey(onSuccess, onError);

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-xl'>
                <HeaderTitle
                    title='modal.add_external_contract.title1'
                    data={{ externalContractName: selectedExtContract.type?.name }}
                    namespace={nsMerchantUser}
                />
                <BodyAddContractForm
                    setValidForm={setValidForm}
                    setFormData={setFormData}
                    selectedExtContract={selectedExtContract}
                />
                <FooterForm
                    onSubmit={() => {
                        const { apiKey, labelTicketTpe } = formData;
                        addContractByApiKey.mutate({
                            apiKey,
                            labelTicketTpe,
                            contractsAccessId,
                            application: selectedExtContract.type?.name
                        });
                    }}
                    isSubmitting={addContractByApiKey.isLoading}
                    isSubmitDisabled={!validForm}
                />
            </ModalContent>
        </Modal>
    );
}

CustomPayModalAddExternalContract.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func
};

export default CustomPayModalAddExternalContract;